import type { FaireProductEntity } from "../../entity_types/product";

export const p_kurv4nsxxk: FaireProductEntity = {
  token: "p_kurv4nsxxk",
  type: "product",
  name: "Rainbow Check Square Stud",
  brandToken: "b_am2enhr6ay",
  brandName: "Slow Day Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/8269baf07860a012e7b8ceabae3cc9e6a016036cb4e15350fbce40fc2fa98e83.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b93cc9720a441f74a2c119c38e44798c9ec7a42741e66e2361e0d64ecb5c1fe0.jpeg",
  ],
  priceDollars: 16,
  description:
    'Size & Weight Information\n\nHeight: 1.75"\n\nWidth: 1.75"\n\nWeight per pair: 5g\n',
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:37:44.235Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
